<div
  style="
    margin: 0 15px 10px 15px;
    font-weight: 500;
    font-size: 0.8rem;
    color: var(--ion-color-medium);
  "
>
  <p>When a new message is received:</p>
</div>
<ion-item>
  <ion-list lines="none" class="no-padding" style="width: 100%">
    <ion-item
      (click)="intakeModeInput = INTAKE_MODES.IMMEDIATE; configChanged()"
      button="true"
      class="ion-item-rounded intake-item"
      [ngClass]="{
        'card-selected': intakeModeInput === INTAKE_MODES.IMMEDIATE
      }"
    >
      <ion-icon name="ticket"></ion-icon>
      <ion-label>{{ INTAKE_MODE_LABELS[INTAKE_MODES.IMMEDIATE] }}</ion-label>
    </ion-item>
    <ion-item
      (click)="intakeModeInput = INTAKE_MODES.FORM; configChanged()"
      button="true"
      class="ion-item-rounded intake-item"
      [ngClass]="{ 'card-selected': intakeModeInput === INTAKE_MODES.FORM }"
    >
      <ion-icon name="document"></ion-icon>
      <ion-label>{{ INTAKE_MODE_LABELS[INTAKE_MODES.FORM] }}</ion-label>
    </ion-item>
    <ion-item
      (click)="intakeModeInput = INTAKE_MODES.BOT_TRIAGE; configChanged()"
      button="true"
      class="ion-item-rounded intake-item"
      [ngClass]="{
        'card-selected': intakeModeInput === INTAKE_MODES.BOT_TRIAGE
      }"
    >
      <ion-icon name="custom-bot"></ion-icon>
      <ion-label>{{ INTAKE_MODE_LABELS[INTAKE_MODES.BOT_TRIAGE] }}</ion-label>
    </ion-item>
  </ion-list>
</ion-item>

<ion-item *ngIf="config?.bot?.enabled">
  <ion-label text-wrap>
    <h3>Handoff mode</h3>
    <p>How should the agent create tickets after conversation</p>
  </ion-label>
  <ion-select
    slot="end"
    interface="popover"
    [(ngModel)]="botHandoffModeInput"
    (ionChange)="configChanged()"
    class="select-outline"
  >
    <ion-select-option [value]="AGENT_HANDOFF_MODES.PROMPT">
      {{ AGENT_HANDOFF_MODE_LABELS[AGENT_HANDOFF_MODES.PROMPT] }}
    </ion-select-option>
    <ion-select-option [value]="AGENT_HANDOFF_MODES.AUTOMATIC">
      {{ AGENT_HANDOFF_MODE_LABELS[AGENT_HANDOFF_MODES.AUTOMATIC] }}
    </ion-select-option>
  </ion-select>
</ion-item>
<ion-item *ngIf="config?.bot?.enabled">
  <ion-label text-wrap style="max-width: unset">
    <h3>Maximum responses</h3>
    <p>
      How many responses before automatic handoff (leave blank for unlimited)
    </p>
  </ion-label>
  <ion-input
    type="number"
    min="1"
    slot="end"
    [(ngModel)]="botMaxResponsesInput"
    (ionChange)="updateMaxResponses()"
    placeholder="Unlimited"
    style="max-width: 120px"
  ></ion-input>
</ion-item>
